export default __webpack_public_path__ + "static/media/doors.17eadd76.png";